import { createHashRouter, createRoutesFromElements, Route } from 'react-router';

import { ErrorBoundary } from '../components/ErrorBoundary';
import AppLayout from '../layout/AppLayout';
import PageLoader from '../layout/PageLoader';
import { DEFAULT_ROUTE } from './routePaths';

export const router = createHashRouter(
    createRoutesFromElements(
        <Route path='/' element={<AppLayout />}>
            <Route path={DEFAULT_ROUTE} errorElement={<ErrorBoundary />} element={<PageLoader />} />
        </Route>
    )
);
